export const toCapitalCase = ( str: string ) => {
  // Fonction de capitalisation du premier caractère d'un mot
  str.toLowerCase()

  const
  First = str.charAt(0),
  regex = new RegExp('^'+ First )

  return First.toUpperCase() + str.split( regex )[1]
}


export const maskEmail = ( email: string ) => {
  const em = email.split('@')
  if( em.length < 2 || em.length > 2 ){
    console.debug('Invalid email address')
    return ''
  }

  const 
  [ id, host ] = em,
  str = id.split(''),
  len = id.length,
  halfLen = len / 2,
  prefix = str.filter( ( each, index ) => (index <= halfLen / 2)).join(''),
  suffix = str.filter( ( each, index ) => (index > halfLen + (halfLen / 2) - 1)).join('')

  return `${prefix}***${suffix}@${host}`
}

export const maskPhone = ( phone: string ) => {
  const
  _phone = phone.split(''),
  len = _phone.length,
  halfLen = len / 2,
  prefix = _phone.filter( ( each, index ) => (index <= halfLen / 2)).join(''),
  suffix = _phone.filter( ( each, index ) => (index > halfLen + (halfLen / 2) - 1)).join('')

  return `${prefix}***${suffix}`
}